module.exports = __webpack_public_path__ + "img/1 (2).622f743e.jpg";